export default __webpack_public_path__ + "static/media/uploader-caresens-1.2e8f94ac.png";